import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  Button,
  CardContent,
  Card,
  Typography,
  Chip,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import StoresDropDown from "../General/StoresDropDown";
import qs from "qs";
import { useDispatch, useSelector } from "react-redux";
import { setSubmitted, selectedProducts } from "redux/productParams";
import {
  addMultipleSelect,
  disable,
  setAllItems,
  setItemsList,
  setItems,
  setAllSelected,
  reset,
  reloadItemsList,
} from "redux/dropDownStores";
import { resetChartData } from "redux/productParams";
import VirtualizedMultiSelect from "components/General/VirtualizedMultiSelect";

const districts = ["1", "2", "5", "22", "23", "24", "25", "26"];
const provinces = ["MB", "NB", "NL", "NS", "ON", "QC", "SK"];

export default function ProductFilterForm({ sendDataToParent }) {
  const [products, setProducts] = useState([]);
  const [productselected, setProductselected] = useState([]);
  const [submitEnabled, setSubmitEnabled] = useState(false);

  const dispatcher = useDispatch();
  const params = useSelector((state) => state.productSales);

  const allMultipleSelects = useSelector((state) => state.stores);
  const componentIdx =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.stores",
    ) === -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.stores",
        );

  const districtsComponent =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.districts",
    ) === -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.districts",
        );

  const provincesComponent =
    allMultipleSelects.findIndex(
      (el) => el.componentName === "products.provinces",
    ) === -1
      ? 0
      : allMultipleSelects.findIndex(
          (el) => el.componentName === "products.provinces",
        );

  const IfMounted = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
      isMountRef.current = false;
    }, []);
    return isMountRef.current;
  };
  const didMounted = IfMounted();

  // Initial bootstrap for stores/districts/provinces
  useEffect(() => {
    dispatcher(addMultipleSelect({ componentName: "products.stores" }));
    dispatcher(addMultipleSelect({ componentName: "products.districts" }));
    dispatcher(addMultipleSelect({ componentName: "products.provinces" }));
    // Stores: two separated choices - "All" (empty + allSelected) vs specific stores
    dispatcher(setItems({ componentName: "products.stores", Items: [] }));
    dispatcher(
      setAllSelected({
        componentName: "products.stores",
        allItemsSelected: true,
      }),
    );
    // Geography: all selected by default (Select All checked)
    dispatcher(
      disable({ componentName: "products.districts", disabled: false }),
    );
    dispatcher(
      disable({ componentName: "products.provinces", disabled: false }),
    );
    dispatcher(setItemsList({ componentName: "products.districts", ItemsList: districts }));
    dispatcher(setItemsList({ componentName: "products.provinces", ItemsList: provinces }));
    dispatcher(setItems({ componentName: "products.districts", Items: districts }));
    dispatcher(setAllSelected({ componentName: "products.districts", allItemsSelected: true }));
    dispatcher(setItems({ componentName: "products.provinces", Items: provinces }));
    dispatcher(setAllSelected({ componentName: "products.provinces", allItemsSelected: true }));
    // keep stores selector enabled
    dispatcher(disable({ componentName: "products.stores", disabled: false }));

    axios
      .get("/api/storesDetail", {
        params: { storeNumber: true },
      })
      .then((res) => {
        dispatcher(
          setAllItems({
            componentName: "products.stores",
            allItems: res.data.nameNumber,
          }),
        );
        dispatcher(
          setItemsList({
            componentName: "products.stores",
            ItemsList: res.data.nameNumber,
          }),
        );
        // Select All ticks all: show every store ticked when All active
        dispatcher(
          setItems({
            componentName: "products.stores",
            Items: res.data.nameNumber,
          }),
        );
        dispatcher(
          setAllSelected({
            componentName: "products.stores",
            allItemsSelected: true,
          }),
        );
      });
  }, []);

  useEffect(() => {
    if (allMultipleSelects[componentIdx]?.reloadItemsList) {
      axios
        .get("/api/storesDetail", {
          params: { storeNumber: true },
        })
        .then((res) => {
          dispatcher(
            setItemsList({
              componentName: "products.stores",
              ItemsList: res.data.nameNumber,
            }),
          );
          dispatcher(
            setAllItems({
              componentName: "products.stores",
              allItems: res.data.nameNumber,
            }),
          );
          // keep Select All ticks all semantics
          dispatcher(
            setItems({
              componentName: "products.stores",
              Items: res.data.nameNumber,
            }),
          );
          dispatcher(
            setAllSelected({
              componentName: "products.stores",
              allItemsSelected: true,
            }),
          );
        });
      dispatcher(reloadItemsList({ componentName: "products.stores" }));
    }
  }, [allMultipleSelects[componentIdx]?.reloadItemsList]);

  // District -> filter stores (All ticks all like stores)
  useEffect(() => {
    if (!didMounted && !allMultipleSelects[districtsComponent]?.disabled) {
      const items = allMultipleSelects[districtsComponent]?.items || [];
      const isAll =
        items.length === 0 ||
        items.length === districts.length ||
        allMultipleSelects[districtsComponent]?.allItemsSelected;
      if (isAll) {
        dispatcher(
          reloadItemsList({
            componentName: "products.stores",
            reloadItemsList: true,
          }),
        );
        return;
      }
      dispatcher(resetChartData());
      dispatcher(reset({ componentName: "products.stores" }));
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      const loadData = async () => {
        const result = await axios.get(
          "/api/districtStoresDetail",
          {
            params: { districtId: items },
            paramsSerializer: (params) =>
              qs.stringify(params, { arrayFormat: "repeat" }),
          },
        );
        dispatcher(
          setItemsList({
            componentName: "products.stores",
            ItemsList: result.data,
          }),
        );
      };
      loadData();
    }
  }, [
    allMultipleSelects[districtsComponent]?.items,
    allMultipleSelects[districtsComponent]?.allItemsSelected,
  ]);

  // Province -> filter stores (All ticks all like stores)
  useEffect(() => {
    if (!didMounted && !allMultipleSelects[provincesComponent]?.disabled) {
      const items = allMultipleSelects[provincesComponent]?.items || [];
      const isAll =
        items.length === 0 ||
        items.length === provinces.length ||
        allMultipleSelects[provincesComponent]?.allItemsSelected;
      if (isAll) {
        dispatcher(
          reloadItemsList({
            componentName: "products.stores",
            reloadItemsList: true,
          }),
        );
        return;
      }
      dispatcher(reset({ componentName: "products.stores" }));
      dispatcher(
        setAllSelected({
          componentName: "products.stores",
          allItemsSelected: false,
        }),
      );
      dispatcher(resetChartData());
      const loadData = async () => {
        const result = await axios.get(
          "/api/provinceStoresDetail",
          {
            params: { provinceId: items },
            paramsSerializer: (params) =>
              qs.stringify(params, { arrayFormat: "repeat" }),
          },
        );
        dispatcher(
          setItemsList({
            componentName: "products.stores",
            ItemsList: result.data,
          }),
        );
      };
      loadData();
    }
  }, [allMultipleSelects[provincesComponent]?.items]);

  // submit enabled logic: needs at least one product
  useEffect(() => {
    if (params.products.length > 0) {
      setSubmitEnabled(true);
    } else {
      setSubmitEnabled(false);
    }
  }, [params.products, allMultipleSelects[componentIdx]?.items]);

  useEffect(() => {
    axios.get("/api/productsDetail").then((res) => {
      setProducts(res.data);
    });
  }, []);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const handleProductChange = (event) => {
    const value = event.target.value || [];
    setProductselected(value);
    dispatcher(
      selectedProducts(
        value.map((item) => item.substring(0, item.indexOf(" "))),
      ),
    );
  };

  function handleSubmit(event) {
    event.preventDefault();
    dispatcher(setSubmitted(true));
    sendDataToParent(startDate, endDate);
  }

  const handleClearGeography = () => {
    dispatcher(setItems({ componentName: "products.districts", Items: districts }));
    dispatcher(setItems({ componentName: "products.provinces", Items: provinces }));
    dispatcher(setAllSelected({ componentName: "products.districts", allItemsSelected: true }));
    dispatcher(setAllSelected({ componentName: "products.provinces", allItemsSelected: true }));
    dispatcher(reloadItemsList({ componentName: "products.stores", reloadItemsList: true }));
  };

  const productOptions = products.map(
    (p) => `${p.product_id} - ${p.product_name}`,
  );

  const isAllDistricts =
    allMultipleSelects[districtsComponent]?.allItemsSelected;
  const isAllProvinces =
    allMultipleSelects[provincesComponent]?.allItemsSelected;
  const geographyActive = !isAllDistricts || !isAllProvinces;

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Box ml={3} mr={3}>
        <Card>
          <CardContent>
            <Box pt={2} pb={2} ml={1}>
              <Grid container spacing={2}>
                {/* Dates */}
                <Grid item md={3} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item md={3} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                    />
                  </LocalizationProvider>
                </Grid>

                {/* Stores (filtered by geography) */}
                <Grid item md={12} xs={12}>
                  <Box pt={1}>
                    <Typography variant="subtitle2" gutterBottom>
                      Stores
                      {geographyActive && (
                        <Chip
                          label="Filtered by geography"
                          size="small"
                          color="primary"
                          sx={{ ml: 1 }}
                        />
                      )}
                    </Typography>
                    <StoresDropDown
                      componentName={"products.stores"}
                      width={600}
                      componentType={"stores"}
                    />
                    <Typography variant="caption" color="textSecondary">
                      Leave empty / Select All = all stores. Use
                      Districts/Provinces below to narrow the list.
                    </Typography>
                  </Box>
                </Grid>

                {/* Geography filters - independent, always enabled */}
                <Grid item md={6} xs={12}>
                  <Box pt={1}>
                    <Typography variant="subtitle2" gutterBottom>
                      Filter stores by geography (optional)
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item md={6} xs={6}>
                        <StoresDropDown
                          componentName={"products.districts"}
                          width={180}
                          componentType={"districts"}
                        />
                      </Grid>
                      <Grid item md={6} xs={6}>
                        <StoresDropDown
                          componentName={"products.provinces"}
                          width={180}
                          componentType={"provinces"}
                        />
                      </Grid>
                    </Grid>
                    {geographyActive && (
                      <Button
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={handleClearGeography}
                      >
                        Clear geography filter
                      </Button>
                    )}
                  </Box>
                </Grid>

                {/* Products - Virtualized with client-side typeahead */}
                <Grid item md={12} xs={12}>
                  <Box pt={3}>
                    <VirtualizedMultiSelect
                      label="Products"
                      id="products-virtualized"
                      value={productselected}
                      options={productOptions}
                      onChange={handleProductChange}
                      width={600}
                      showSelectAll={false}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box pt={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={!submitEnabled}
                    >
                      Submit
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </form>
  );
}
